<template>
  <div>
    <b-row>
      <b-col md="4" cols="12" class="d-flex">
        <b-card class="d-flex flex-column w-100 budget-bg">
          <h4 class="font-weight-bolder text-center mb-2">Current budget</h4>
          <b-skeleton
            v-if="loadingStatistics"
            width="80px"
            height="20px"
            class="mx-auto"
          />
          <h4 class="mb-25 text-center text-white h3" v-else>
            {{
              statistics.current_balance
                ? statistics.current_balance.toFixed(2)
                : "0"
            }}<span class="text-warning ml-50">$</span>
          </h4>
          <div class="d-flex justify-content-center align-items-center mb-1">
            <small class="mr-25">Budget:</small>
            <b-skeleton
              v-if="loadingStatistics"
              width="50px"
              height="15px"
              class="mb-0"
            />
            <small v-else>{{
              statistics.total_deposit && statistics.total_withdraw
                ? (
                    statistics.total_deposit + statistics.total_withdraw
                  ).toFixed(2)
                : "0"
            }}</small>
          </div>

          <div class="d-flex justify-content-center py-3">
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              class="gradient-btn px-3 py-1"
              v-if="$route.name == 'wallet-overview'"
              @click="visibleCreateDeposit = true"
            >
              Add Budget
            </b-button>
          </div>
          <div class="px-3 pt-3">
            <vue-apex-charts
              id="budget-chart"
              type="line"
              height="80"
              :options="budgetChart.options"
              :series="budgetChart.series"
            />
          </div>
        </b-card>
      </b-col>
      <b-col md="4" cols="12" class="d-flex">
        <b-card class="d-flex flex-column w-100">
          <h3 class="font-weight-bolder mb-2 text-center pb-md-2">
            Latest transactions
          </h3>
          <template v-if="loading">
            <div
              class="d-flex justify-content-between my-1"
              v-for="i in 5"
              :key="i"
            >
              <b-skeleton width="20%" height="20px" />
              <b-skeleton width="40%" height="20px" />
              <b-skeleton width="20%" height="20px" />
            </div>
          </template>
          <template v-else-if="transactions.length">
            <div class="w-100 c-table">
              <div
                v-for="(overview, index) in transactions"
                :key="index"
                class="w-100 p-0 mb-50"
                style="white-space: nowrap"
              >
                <div
                  class="d-flex align-items-center bg-secondary rounded"
                  style="min-width: 400px"
                >
                  <div
                    v-if="overview.type == 'deposit'"
                    class="p-2 d-flex col-2"
                  >
                    <b-img
                      :src="
                        require('@/assets/images/fxlegends/icon-useroverviewAsset 42.svg')
                      "
                      width="30"
                      height="30"
                    />
                  </div>
                  <div v-else class="p-2 d-flex col-2">
                    <b-img
                      :src="
                        require('@/assets/images/fxlegends/icon-useroverviewAsset 43.svg')
                      "
                      width="30"
                      height="30"
                    />
                  </div>
                  <div class="d-flex flex-column col-6">
                    <span class="font-weight-bolder d-flex flex-nowrap">{{
                      hasOwnNestedProperty(overview, "payable.first_name")
                        ? overview.payable.first_name +
                          " " +
                          overview.payable.last_name
                        : hasOwnNestedProperty(overview, "payable.name")
                        ? overview.payable.name
                        : "-"
                    }}</span>
                    <small class="d-flex">{{
                      hasOwnNestedProperty(overview, "meta.message")
                        ? overview.meta.message
                        : hasOwnNestedProperty(overview, "meta.data.message")
                        ? overview.meta.data.message
                        : "-"
                    }}</small>
                  </div>
                  <div
                    :class="
                      overview.type == 'deposit'
                        ? 'text-success'
                        : 'text-danger'
                    "
                    class="px-1 d-flex justify-content-center col-4"
                  >
                    {{
                      (overview.amount_float > 0 ? "$+" : "$") +
                      Math.abs(overview.amount_float).toFixed(2)
                    }}
                    %
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="d-flex align-items-center justify-content-center h-75 new-alert"
            >
              <b-alert
                show
                variant="secondary"
                class="d-flex align-items-center justify-content-center h-100 w-100"
              >
                no information
              </b-alert>
            </div>
          </template>
        </b-card>
      </b-col>

      <b-col md="4" cols="12" class="d-flex">
        <b-card class="d-flex flex-column w-100">
          <h3 class="font-weight-bolder text-center mb-2">Profitability</h3>
          <div v-if="loadingStatistics">
            <div class="d-flex align-items-center justify-content-center">
              <b-skeleton
                class="rounded-circle mr-0"
                width="140px"
                height="140px"
              ></b-skeleton>
            </div>
            <div class="d-flex align-items-center justify-content-center mt-1">
              <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
              <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
            </div>
          </div>
          <div
            class="py-2"
            v-else-if="
              statistics.total_deposit != null &&
              statistics.total_withdraw != null
            "
          >
            <doughnut-chart
              :chartData="chartData"
              :colors="['#FA4B68', '#2CD889']"
              :labels="['deposit', 'withdraw']"
              height="160px"
              width="160px"
            />
          </div>
          <template v-else>
             <div class="d-flex justify-content-center h-100 new-alert">
          <div
            class="mt-2"
            style="
              border-radius: 100px;
              height: 115px;
              width: 115px;
              border: 23px solid rgb(45 45 53 / 44%);
            "
          > </div> 
        </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <create-deposit-modal
      v-if="$route.name == 'wallet-overview'"
      :visible="visibleCreateDeposit"
      v-model="visibleCreateDeposit"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BSkeleton,
  BAlert,
  BImg,
} from "bootstrap-vue";
import { $themeColors } from "@themeConfig";
import VueApexCharts from "vue-apexcharts";
import Ripple from "vue-ripple-directive";
import CreateDepositModal from "./deposit/CreateDepositModal.vue";
import DoughnutChart from "@/views/components/doughnut-chart/DoughnutChart.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    VueApexCharts,
    CreateDepositModal,
    BSkeleton,
    BAlert,
    BImg,
    DoughnutChart,
  },
  directives: {
    Ripple,
  },
  props: {
    statistics: {
      type: Object,
      default: () => {},
    },
    loadingStatistics: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleCreateDeposit: false,

      budgetChart: {
        options: {
          chart: {
            height: 80,
            toolbar: { show: false },
            zoom: { enabled: false },
            type: "line",
            sparkline: { enabled: true },
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 5],
            width: [2],
          },
          colors: ["#4CAF50", $themeColors.danger],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.5,
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [20, 100, 100, 100],
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        series: [
          {
            data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
          },
          {
            data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
          },
        ],
      },
      transactions: [],
      loading: false,
    };
  },
  $route: {
    handler(val) {
      this.getTransactions();
    },
    immediate: true,
    deep: true,
  },
  methods: {
    calApiRoute(path) {
      return this.$route.name.includes("competition")
        ? `/panel/competitions/${this.$route.params.id}/${path}`
        : this.$route.name.includes("user")
        ? `/panel/users/${this.$route.params.id}/${path}`
        : this.$route.name.includes("partner")
        ? `/panel/partners/${this.$route.params.id}/${path}`
        : this.$route.name.includes("plan")
        ? `/panel/plans/${this.$route.params.id}/${path}`
        : `/panel/profile/user/${path}`;
    },
    async getTransactions() {
      this.loading = true;
      try {
        const params = {
          per_page: 4,
        };
        const { data } = await this.$http.get(
          this.calApiRoute("transactions"),
          {
            params,
          }
        );
        this.transactions = data.data;
      } catch (err) {}
      this.loading = false;
    },
  },
  computed: {
    chartData() {
      return [
        (
          (100 /
            (Math.abs(this.statistics.total_deposit) +
              Math.abs(this.statistics.total_withdraw))) *
          Math.abs(this.statistics.total_deposit)
        ).toFixed(2),
        (
          (100 /
            (Math.abs(this.statistics.total_deposit) +
              Math.abs(this.statistics.total_withdraw))) *
          Math.abs(this.statistics.total_withdraw)
        ).toFixed(2),
      ];
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
